import UsersTable from './users/Table'

export default Vue => {
  Vue.component(UsersTable.name, UsersTable)
}
